// Formats a list of membership level names into a sentence fragment, e.g.
// ['plus', 'pro', 'gold'] -> "Plus, Pro, or Gold" and ['gold'] -> "Gold".
// Tolerates a missing/empty list (a member level with no upgrade path, such
// as Gold) by returning '' instead of throwing.
export function formatMembershipLevels(levels) {
  if (!levels?.length) return '';

  return levels.map((level, i) => {
    const capitalizedLevel = `${level[0].toUpperCase()}${level.slice(1)}`;

    if (i === 0) return capitalizedLevel;

    if (levels.length > 2) {
      return i < levels.length - 1
        ? `, ${capitalizedLevel}`
        : `, or ${capitalizedLevel}`
    };

    return ` or ${capitalizedLevel}`
  }).join('');
}
